// eslint-disable-next-line no-unused-vars
import React, { useEffect, memo, useState, useRef } from 'react';
import { useContextSelector } from 'use-context-selector';

import { UserContext } from 'Contexts/UserContext';
import SettingsMenuComponent from 'Components/Menus/Settings';
import useOutsideClick from 'Hooks/useOutsideClick';

const SettingsMenu = memo(() => {
  const {
    data: { defaultCurrency: currency, withVat: vat },
    updateUser,
  } = useContextSelector(
    UserContext,
    data => data
  );
  const currencyRef = useRef(null);
  const isCurrencyVisible = useOutsideClick(currencyRef);
  const vatRef = useRef(null);
  const isVatVisible = useOutsideClick(vatRef);
  const [loading, setLoading] = useState(false);
  const [selectedCurrency, setCurrency] = useState(currency);
  const [selectedVat, setVat] = useState(vat);
  const [currencyOpen, setCurrencyOpen] = useState(false);
  const [vatOpen, setVatOpen] = useState(false);

  useEffect(() => {
    if (
      currency
      && currency !== selectedCurrency
    ) {
      setCurrency(currency?.toLowerCase());
    }
  }, [currency]);

  useEffect(() => {
    if (vat !== selectedVat) {
      setVat(vat);
    }
  }, [vat]);

  useEffect(() => {
    setCurrencyOpen(isCurrencyVisible);
  }, [isCurrencyVisible]);

  useEffect(() => {
    setVatOpen(isVatVisible);
  }, [isVatVisible]);

  const handleCurrencyToggle = () => {
    setCurrencyOpen(prevOpen => !prevOpen);
  };

  const handleVatToggle = () => {
    setVatOpen(prevOpen => !prevOpen);
  };

  const handleCurrencyChange = async selectedItem => {
    setCurrency(selectedItem);

    try {
      setLoading(true);
      await updateUser({
        withVat: selectedVat,
        defaultCurrency: selectedItem
      });
    } catch (err) {
      setCurrency(currency);
    } finally {
      setLoading(false);
    }
  };

  const handleVatChange = async selectedItem => {
    setVat(selectedItem);

    try {
      setLoading(true);
      await updateUser({
        withVat: !!selectedItem,
        defaultCurrency: selectedCurrency
      });
    } catch (err) {
      setVat(vat);
    } finally {
      setLoading(false);
    }
  };

  return (
    // <DropdownContext.Comsumer>
    //   {
    //     isOpen => {
    <SettingsMenuComponent
      ref={ { currencyRef, vatRef } }
      currencyOpen={ currencyOpen }
      vatOpen={ vatOpen }
      // toggleDropdown={ toggleDropdown() }
      setDropdown={ setCurrencyOpen }
      loading={ loading }
      selectedCurrency={ selectedCurrency }
      selectedVat={ selectedVat ? 1 : 0 }
      handleCurrencyChange={ handleCurrencyChange }
      handleVatChange={ handleVatChange }
      onCurrencyToggle={ handleCurrencyToggle }
      onVatToggle={ handleVatToggle }
    />
    //     }
    //   }
    // </DropdownContext.Comsumer>
  );
});
SettingsMenu.displayName = 'SettingsMenuContainer';

export default SettingsMenu;
